// 一局結算結果型別
// 從 events.ts 拆出：結算型別與 scoring 同層，讓事件 map（events.ts）反過來 import 它，
// 避免「事件契約檔」被迫反向依賴計分層（scoring）。

import type { TScoreItem } from './scoring';
import type { TTile } from './tile';
import type { TSeat } from './types';

/**
 * 唯一成立玩家的胡牌結果；正式牌局採順位攔胡。
 */
export type THuResult = {
  readonly seat: TSeat;
  readonly isSelfDraw: boolean;
  /** 放槍者；自摸時為 null。 */
  readonly loserSeat: TSeat | null;
  readonly winTile: TTile;
  readonly scoreItems: readonly TScoreItem[];
  readonly total: number;
};

/** 一局結束總結的 kind const。 */
export const RoundSummaryKind = {
  Hu: 'hu',
  Draw: 'draw',
} as const;

export type TRoundSummaryKind = (typeof RoundSummaryKind)[keyof typeof RoundSummaryKind];

/** 一局結束的總結。 */
export type TRoundSummary =
  /** results 沿用陣列以降低 UI 改動，但正式核心保證最多一筆。 */
  | { readonly kind: typeof RoundSummaryKind.Hu; readonly results: readonly THuResult[] }
  | { readonly kind: typeof RoundSummaryKind.Draw };
